import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=eddb685c&scoped=true&"
import script from "./order-summary.component.ts?vue&type=script&lang=ts&"
export * from "./order-summary.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-summary.scss?vue&type=style&index=0&id=eddb685c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb685c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddb685c')) {
      api.createRecord('eddb685c', component.options)
    } else {
      api.reload('eddb685c', component.options)
    }
    module.hot.accept("./order-summary.vue?vue&type=template&id=eddb685c&scoped=true&", function () {
      api.rerender('eddb685c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-pricerite/components/order-summary/order-summary.vue"
export default component.exports